import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { post } from "@insite/client-framework/Services/ApiService";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import {
    chain,
    SendDataToApi,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter>;

const emailsUrl = "/api/v1/email";

export function submitContactUsExtendedForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter, void>(`${emailsUrl}/contactUsExtended`, parameter);
}

export const SendDataToCustomApi: HandlerType = async props => {
    await submitContactUsExtendedForm(props.apiParameter);
};

replaceInChain(chain, SendDataToApi, SendDataToCustomApi);
